import { Overview, TreeMap } from "@similarweb/icons";

import { DomainsMap } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/domain-influence/domains-map/DomainsMap";
import { InfluenceOverTimeGraph } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/domain-influence/influence-over-time-graph/InfluenceOverTimeGraph";
import type {
    IViewData,
    InfluenceView,
} from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/sources-report/domain-influence/types";

export const MAX_DOMAINS = 37;
export const NO_TOPICS_ID = "no-topics";
export const DEFAULT_INFLUENCE_VIEW: InfluenceView = "treeMap";
export const VIEWS_CONFIG: Record<InfluenceView, IViewData> = {
    treeMap: {
        component: DomainsMap,
        icon: <TreeMap />,
        trackingName: "Tree map",
    },
    overTimeGraph: {
        component: InfluenceOverTimeGraph,
        icon: <Overview />,
        trackingName: "Over time",
    },
};

export const SWITCHER_ITEMS = Object.entries(VIEWS_CONFIG).map(([view, data]) => ({
    title: data.icon,
    value: view,
}));
